import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-company-users',
  templateUrl: './company-users.component.html',
  styleUrls: ['./company-users.component.css']
})
export class CompanyUsersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
